module.exports = __webpack_public_path__ + "static/img/thumb_01.152df97.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/about/thumb_01.jpg
// module id = 28
// module chunks = 0